import { render, staticRenderFns } from "./custom-table-head.component.vue?vue&type=template&id=b92b8e7a&"
import script from "./custom-table-head.component.ts?vue&type=script&lang=js&"
export * from "./custom-table-head.component.ts?vue&type=script&lang=js&"
import style0 from "./custom-table-head.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports